const firebaseConfig = {
    apiKey: "AIzaSyCMetmoNGK2SeCbvPDOFZuEX_rlvGqBHUo",
    authDomain: "empire-hospital.firebaseapp.com",
    projectId: "empire-hospital",
    storageBucket: "empire-hospital.appspot.com",
    messagingSenderId: "645620879649",
    appId: "1:645620879649:web:db2c4fb261225f3f01ee60"
};

export default firebaseConfig;